var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatementPreference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 45a6.506 6.506 0 01-6.5-6.499A6.508 6.508 0 0132.5 32c3.583 0 6.5 2.915 6.5 6.501A6.506 6.506 0 0132.5 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.642 34.788l-2.265-.362h-.036a11.167 11.167 0 00-1.003-2.422l.032-.03 1.34-1.852a1.606 1.606 0 00-.166-2.086l-1.583-1.58a1.605 1.605 0 00-2.083-.17l-1.856 1.347-.026.029a11.019 11.019 0 00-2.424-1.003v-.039l-.363-2.264A1.6 1.6 0 0033.62 23H31.38a1.6 1.6 0 00-1.59 1.356l-.363 2.264v.039a10.95 10.95 0 00-2.424 1.003l-.026-.03-1.856-1.345a1.605 1.605 0 00-2.083.17l-1.583 1.582a1.6 1.6 0 00-.167 2.08l1.341 1.854.032.032a11.118 11.118 0 00-1.003 2.421h-.044l-2.257.362A1.605 1.605 0 0018 36.382v2.238c0 .795.57 1.462 1.358 1.59l2.257.36h.044c.242.853.577 1.668 1.003 2.424l-.03.03-1.343 1.853a1.607 1.607 0 00.167 2.085l1.585 1.58c.302.305.708.474 1.138.474.339 0 .667-.106.943-.304l1.856-1.346.029-.027c.756.426 1.568.761 2.421 1v.044l.363 2.257c.126.79.793 1.361 1.59 1.361h2.238c.797 0 1.464-.57 1.59-1.36l.363-2.263v-.038a11.06 11.06 0 002.423-1l.027.026 1.856 1.346a1.612 1.612 0 002.083-.17l1.583-1.58a1.604 1.604 0 00.167-2.083l-1.344-1.856-.029-.029c.426-.756.761-1.57 1.003-2.424h.036l2.265-.36A1.606 1.606 0 0047 38.62V36.38c0-.797-.57-1.467-1.358-1.593M9 13.5h6M9 20.5h11M9 27.5h6M9 34.5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015 45h-8.02C1.998 44.986 1 43.7 1 41.142V4.529C1.17 2.176 2.47 1 4.902 1h18.04L35 12.664v3.445-2.46h-8.631c-2.183 0-3.334-1.186-3.453-3.557V2.127"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementPreference);
export default __webpack_public_path__ + "static/media/statement-preference.32cde347.svg";
export { ForwardRef as ReactComponent };